import { SignIn } from "@clerk/clerk-react";

export const SignInPage = () => {
	return (
		<div className="flex items-center justify-center min-h-screen bg-clyr-gray-900">
			<SignIn
				routing="path"
				path="/sign-in"
				appearance={{
					elements: {
						footerAction: { display: "none" },
					},
				}}
			/>
		</div>
	);
};
